import $ from 'jquery';

class Cookies {
    constructor() {
        this.$ = $;

        this.$cookiesButton = this.$('.js-open-cookie-popup-button');

        this.$cookiesButton.on('click', this.$.proxy(this.showCookies, this));
    }

    showCookies() {
        CookieControl.open();
    }
}

export default Cookies;
